import React, { useState, useEffect } from 'react'
import Loader from 'react-loaders'
import './Contact.scss'
import AnimatedLettrs from '../AnimatedLetters/AnimatedLettrs'
import emailjs from '@emailjs/browser'
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet'
type Props = {}

const Contact = (props: Props) => {
  //   const emailjsApiKey = process.env.EMAILJS_API_KEY

  const [letterClass, setLetterClass] = useState('text-animate')
  const form = React.useRef<HTMLFormElement>(null)
  useEffect(() => {
    setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 3000)
  }, [])
  const sendEmail = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    if (form.current instanceof HTMLFormElement) {
      emailjs
        .sendForm(
          'gmail',
          'template_vgpuues',
          form.current,
          'S0E2Ai9g7kPAh0Mm_'
          //   emailjsApiKey
        )
        .then(
          () => {
            alert('Message successfully sent!')
            window.location.reload()
          },
          () => {
            alert('Failed to send the message, please try again')
          }
        )
    }
  }
  return (
    <>
      <div className="container contact-page">
        <div className="text-zone">
          <h1>
            <AnimatedLettrs
              strArray={'Contact me'.split('')}
              idx={15}
              letterClass={letterClass}
            />
          </h1>
          <p>
            I am interested in all kinds of opportunities in web development. If
            you have any requests or questions, please don't hesitate to contact
            me using the form below.
          </p>
          <div className="contact-form">
            <form ref={form} onSubmit={sendEmail}>
              <div className="flex column user-form">
                <div className="half flex">
                  <input type="text" name="name" placeholder="Name" required />
                  <input
                    type="email"
                    name="email"
                    placeholder="Email"
                    required
                  />
                </div>
                <div className="flex column">
                  <input
                    type="text"
                    name="subject"
                    placeholder="Subject"
                    required
                  />
                  <textarea name="message" placeholder="Message" required />
                </div>
              </div>
              <input type="submit" className="flat-button" value="SEND" />
            </form>
          </div>
        </div>
        <div className="info-map">
          Volodymyr Sokolenko,
          <br />
          Ukraine,
          <br />
          Dnipro
          <br />
          <span> vvs.0503624459@gmail.com</span>
        </div>
        <div className="map-wrap">
          <MapContainer center={[48.415993, 35.070312]} zoom={13}>
            <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
            <Marker position={[48.415993, 35.070312]}>
              <Popup> come over for a cup of coffee :)</Popup>
            </Marker>
          </MapContainer>
        </div>
      </div>

      <Loader type="pacman" active />
    </>
  )
}

export default Contact
